import { LISTED_CFD_INSTRUMENTS, getListedCfdInstrument } from '../../supabase/functions/_shared/cfdInstruments';

export const VALORE_FOREX_PAIRS = [
  'EUR/USD', 'GBP/USD', 'AUD/USD', 'NZD/USD', 'USD/JPY', 'USD/CHF', 'USD/CAD',
  'EUR/JPY', 'EUR/GBP', 'EUR/AUD', 'EUR/CHF', 'EUR/CAD', 'EUR/NZD',
  'GBP/JPY', 'GBP/AUD', 'GBP/CHF', 'GBP/CAD', 'GBP/NZD',
  'AUD/CAD', 'AUD/CHF', 'AUD/JPY', 'AUD/NZD',
  'NZD/JPY', 'NZD/CHF', 'NZD/CAD',
  'CAD/JPY', 'CAD/CHF', 'CHF/JPY',
  'USD/TRY', 'EUR/TRY', 'USD/ZAR', 'USD/HKD', 'USD/SGD',
  'USD/DKK', 'USD/NOK', 'USD/SEK', 'USD/PLN', 'USD/HUF', 'USD/CZK',
  'USD/MXN', 'USD/BRL', 'USD/CNH', 'USD/THB', 'USD/IDR',
  'AUD/SGD', 'AUD/HKD', 'NZD/SGD', 'SGD/JPY', 'HKD/JPY',
  'USD/TWD', 'USD/KRW', 'USD/INR', 'USD/PHP', 'USD/MYR',
  'EUR/SEK', 'EUR/NOK', 'EUR/DKK', 'EUR/PLN', 'EUR/HUF', 'EUR/CZK',
  'USD/SAR', 'USD/AED', 'USD/QAR', 'USD/ILS', 'EUR/ILS',
  'USD/CLP', 'USD/COP', 'USD/PEN',
  'EUR/ZAR', 'GBP/ZAR', 'AUD/ZAR'
];

export const VALORE_COMMODITY_PAIRS = [
  'XAU/USD', 'XAG/USD', 'XPT/USD', 'XPD/USD',
  'WTICO/USD', 'BCO/USD', 'NATGAS/USD',
  'CORN/USD', 'WHEAT/USD', 'SUGAR/USD'
];

export const VALORE_STOCKS = [
  'AAPL', 'MSFT', 'GOOGL', 'AMZN', 'TSLA', 'META', 'NFLX', 'NVDA',
  'BA', 'JPM', 'GS', 'BAC', 'WMT', 'DIS', 'CVX',
  'AMD', 'INTC', 'ORCL', 'IBM', 'ADBE', 'PYPL', 'UBER', 'LYFT',
  'PFE', 'MRNA', 'KO', 'PEP', 'XOM', 'T', 'V', 'MA',
  'CSCO', 'CRM', 'COST', 'AVGO', 'TXN', 'QCOM', 'AMAT', 'INTU', 'SBUX', 'MCD'
];

export const VALORE_INDICES = [
  'SPX', 'DJI', 'NDX', 'RUT', 'VIX',
  'DAX', 'FTSE', 'CAC', 'N225', 'HSI', 'AS51', 'STOXX50E', 'SMI',
  'IXIC'
];

export const ALL_VALORE_SYMBOLS = [
  ...VALORE_FOREX_PAIRS,
  ...VALORE_COMMODITY_PAIRS,
  ...VALORE_STOCKS,
  ...VALORE_INDICES,
  ...LISTED_CFD_INSTRUMENTS.map(instrument => instrument.symbol)
];

const valoreSymbolSet = new Set(ALL_VALORE_SYMBOLS);

export function isValoreSupported(symbol: string): boolean {
  return valoreSymbolSet.has(symbol);
}

export function normalizeToValoreSymbol(symbol: string): string | null {
  if (symbol.includes('OANDA:')) {
    const cleaned = symbol.replace('OANDA:', '').replace('_', '/');
    return valoreSymbolSet.has(cleaned) ? cleaned : null;
  }

  if (symbol.includes('_')) {
    const converted = symbol.replace('_', '/');
    return valoreSymbolSet.has(converted) ? converted : null;
  }

  return valoreSymbolSet.has(symbol) ? symbol : null;
}

export function getAssetType(symbol: string): 'forex' | 'commodity' | 'stock' | 'index' | 'etf' | null {
  const listing = getListedCfdInstrument(symbol);
  if (listing) return listing.type;
  if (VALORE_FOREX_PAIRS.includes(symbol)) return 'forex';
  if (VALORE_COMMODITY_PAIRS.includes(symbol)) return 'commodity';
  if (VALORE_STOCKS.includes(symbol)) return 'stock';
  if (VALORE_INDICES.includes(symbol)) return 'index';
  return null;
}
